<template>
<b-modal
      id="item_summary_popupmodal"
      ref="item_summary_popupmodal"
      title="Item Summary"
      title-tag="h3" 
      ok-only
      modal-class="common_pop">
      <div class="section_itemsummary" v-if="result.PC_TYPE == 'CDI'">
        <div class="samediv">
            <p>Tag: {{result.DATA["ProjectName"]}}</p>
        </div>
        <div class="samediv">
            <p>Fabric Name: {{result.DATA["FabricName"]}}</p>
        </div>
        <div class="samediv">
            <p>Style: {{result.DATA["Style"]}}</p>
            <p v-if="result.DATA['Style'] == 'Grommet'">Color & Size: {{result.DATA["ColorSize"]}}</p>
            <p v-else-if="result.DATA['Style'] == 'Shirred'">Pocket Size & Header Size: {{result.DATA["PocketSize"]}} {{result.DATA["HeaderSize"]}}</p>
            <p v-else>Pin Setting: {{result.DATA["PinSetting"]}}</p>
        </div>
        <div class="samediv">
            <p>{{result.DATA["PairPanel"]}}</p>
            <p>Rod Width: {{Number(result.DATA["RodInches"]).toFixed(2)}}</p>
            <p>Left Return (in): {{Number(result.DATA["LeftReturn"]).toFixed(2)}}</p>
            <p>Right Return (in): {{Number(result.DATA["RightReturn"]).toFixed(2)}}</p>
            <p v-if="(result.DATA['FabricType']).toLowerCase() == 'sheer by inch program' && (result.DATA['PairPanel']).toLowerCase() == 'pair'">Overlap(in): {{Number(result.DATA["OverlapInches"]).toFixed(2)}}</p>
            <p v-else-if="(result.DATA['PairPanel']).toLowerCase() == 'pair'">Overlap(in): {{Number(result.DATA["Overlap"]).toFixed(2)}}</p>
            <p>Fullness: {{Number(result.DATA["Fullness"]).toFixed(2)}}</p>
            <p>Finished Length (in): {{Number(result.DATA["FinishedLength"]).toFixed(2)}}</p>
        </div>
        <div class="samediv">
            <p>Lining: {{result.DATA["Lining"]}}</p>
            <p>Interlining: {{result.DATA["Interlining"]}}</p>
        </div>
        <div class="samediv" v-if="result.DATA['TrimmingType'] != 'No Trim'">
            <p>Vertical Trimming: {{result.DATA["TrimmingPattern"]}}</p>
            <p>Vertical Trimming Color: {{result.DATA["TrimmingColor"]}}</p>
            <p>Vertical Trimming Type: {{result.DATA["TrimmingType"]}}</p>
        </div>
        <div class="samediv">
            <p>Notes: {{result.DATA["Notes"]}}</p>
        </div>
        <div class="samediv">
            <button class="btn btn-dark" @click="hideModal()">Return to Cart</button>
        </div>
      </div>
      <div class="section_itemsummary" v-if="result.PC_TYPE == 'CDIP'">
        <div class="samediv">
            <p>Tag: {{result.DATA[0]["Sidemark"]}}</p>
        </div>
        <div class="samediv">
            <p>Pattern: {{result.DATA[0]["Pattern"]}}</p>
            <p>Color: {{result.DATA[0]["Color"]}}</p>
        </div>
        <div class="samediv">
            <p>Pleat Style: {{result.DATA[0]["Style"]}}</p>
            <p>Pin Setting: {{result.DATA[0]["Pin Setting"]}}</p>
        </div>
        <div class="samediv">
            <p>{{result.DATA[0]["Panel or Pair"]}}</p>
            <p>Rod Width: {{Number(result.DATA[0]["Rod Width"]).toFixed(2)}}</p>
            <p>Left Return (in): {{Number(result.DATA[0]["Left Return"]).toFixed(2)}}</p>
            <p>Right Return (in): {{Number(result.DATA[0]["Right Return"]).toFixed(2)}}</p>
            <p>Overlap(in): {{Number(result.DATA[0]["Overlap"]).toFixed(2)}}</p>
            <p>Finished Width (in): {{Number(result.DATA[0]["Finish Width"]).toFixed(2)}}</p>
            <p>Fullness: {{Number(result.DATA[0]["Fullness"]).toFixed(2)}}</p>
            <p>Total Widths: {{Number(result.DATA[0]["Total Widths"]).toFixed(2)}}</p>
            <p>Finished Length (in): {{Number(result.DATA[0]["Finish Length"]).toFixed(2)}}</p>
            <p>Yards Required: {{Number(result.DATA[0]["Yards Required"]).toFixed(2)}}</p>
        </div>
        <div class="samediv" v-if="result.DATA[0]['Lining'] == 'Yes'">
            <p>Lining: {{result.DATA[0]["Lining Type"]}}</p>
            <p>Lining Color: {{result.DATA[0]["Lining Color"]}}</p>
            <p>RM Designer Interlining: {{result.DATA[0]["Interlining Color"]}}</p>
        </div>
        <div class="samediv" v-if="result.DATA[0]['Vertical Trimming'] == 'Yes'">
            <p>Vertical Trimming: {{result.DATA[0]["Vertical Trimming Pattern"]}}</p>
            <p>Vertical Trimming Color: {{result.DATA[0]["Vertical Trimming Color"]}}</p>
            <p>Vertical Trimming Placement: {{result.DATA[0]["Vertical Trimming Placement"]}}</p>
            <p>Vertical Trimming Position: {{result.DATA[0]["Vertical Trimming Trim Position"]}}</p>
            <p>Yards Required: {{Number(result.DATA[0]["Vertical Trimming Yardare Required"]).toFixed(2)}}</p>
        </div>
        <div class="samediv">
            <p>Notes: {{result.DATA[0]["Notes"]}}</p>
        </div>
        <div class="samediv">
            <button class="btn btn-dark" @click="hideModal()">Return to Cart</button>
        </div>
      </div>
      <div class="section_itemsummary" v-if="result.PC_TYPE == 'CDIQ'">
          <div class="samediv">
            <p>Tag: {{result.DATA["ProjectName"]}}</p>
        </div>
        <div class="samediv">
            <p>Fabric Name: {{result.DATA["FabricName"]}}</p>
        </div>
        <div class="samediv">
            <p>Style: {{result.DATA["Style"]}}</p>
            <p v-if="result.DATA['Style'] == 'Grommet'">Color & Size: {{result.DATA["ColorSize"]}}</p>
            <p v-else>Pin Setting: {{result.DATA["PinSetting"]}}</p>
        </div>
        <div class="samediv">
            <p>{{result.DATA["PairPanel"]}}</p>
            <p>Rod Width: {{Number(result.DATA["RodInches"]).toFixed(2)}}</p>
            <p>Left Return (in): {{Number(result.DATA["LeftReturn"]).toFixed(2)}}</p>
            <p>Right Return (in): {{Number(result.DATA["RightReturn"]).toFixed(2)}}</p>
            <p>Overlap(in): {{Number(result.DATA["Overlap"]).toFixed(2)}}</p>
            <p>Fullness: {{Number(result.DATA["Fullness"]).toFixed(2)}}</p>
            <p>Finished Length (in): {{Number(result.DATA["FinishedLength"]).toFixed(2)}}</p>
        </div>
        <div class="samediv">
            <p>Lining: {{result.DATA["Lining"]}}</p>
        </div>
        <div class="samediv">
            <p>Notes: {{result.DATA["Notes"]}}</p>
        </div>
        <div class="samediv">
            <button class="btn btn-dark" @click="hideModal()">Return to Cart</button>
        </div>
      </div>
    </b-modal>
</template>

<script>
export default {
  methods: {
    show(dataarr){
        this.result = dataarr;
        this.$refs["item_summary_popupmodal"].show();
    },
    hideModal(){
        this.$refs["item_summary_popupmodal"].hide();
    }
  },
  data() {
    return {
      result: []
    };
  },
};
</script>

<style>
.section_itemsummary .samediv {
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.section_itemsummary .samediv:last-child {
    padding-bottom: 0;
}
.section_itemsummary .samediv p{
    width: 100%;
    text-align: left;
}
.section_itemsummary .samediv button{
    padding: 0 20px;
}
</style>
